import { useMemo } from 'react';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { FormAsyncSelectField, lt } from '@mews/framework';
import { useCityLedgerMultipleInvoicesContext } from '../../../context/CityLedgerMultipleInvoicesContext';
import { useAccountSearch } from '../../../hooks/useAccountSearch';
import { renderAccountList } from './renderAccountList';

interface PayerAccountSelectProps {
    name: string;
}

export const PayerAccountSelect = ({ name }: PayerAccountSelectProps) => {
    const { ownerIds } = useCityLedgerMultipleInvoicesContext();

    const { data } = useRepositoryQuery('accounts', 'getAll', { accountIds: ownerIds });

    const defaultOptions = useMemo(
        () =>
            renderAccountList({
                customers: data?.customers ?? [],
                companies: data?.companies ?? [],
            }),
        [data?.companies, data?.customers]
    );

    const finalDefaultValue = ownerIds.length === 1 ? ownerIds[0] : null;

    const accountSearch = useAccountSearch();

    return (
        <FormAsyncSelectField
            name={name}
            label={lt('CityLedgerSelectPaymentOwner')}
            helper={lt('CityLedgerSelectPaymentOwnerHelperText')}
            useDataQuery={accountSearch}
            defaultOptions={defaultOptions}
            renderData={renderAccountList}
            searchPlaceholder={lt('SearchByName')}
            defaultValue={finalDefaultValue}
            data-test-id="payer-account-select"
        />
    );
};
